import { categoryKey } from './menuStructure';

export function duplicateDish(menu, index) {
  if (!menu[index] || menu.length >= 150) return menu;
  const item = menu[index];
  const copy = { ...item, name: `${item.name.slice(0, 92)} (copia)`, verified: false, allergenStatus: 'unknown',
    allergens: [...(item.allergens || [])], ...(item.variants ? { variants: item.variants.map(v => ({ ...v })) } : {}) };
  return [...menu.slice(0, index + 1), copy, ...menu.slice(index + 1)];
}

export function adjacentDish(menu, index, direction) {
  if (!menu[index] || ![-1, 1].includes(direction)) return -1;
  const key = categoryKey(menu[index]?.category);
  for (let i = index + direction; i >= 0 && i < menu.length; i += direction) {
    if (categoryKey(menu[i].category) === key) return i;
  }
  return -1;
}

export function moveDish(menu, index, direction) {
  const target = adjacentDish(menu, index, direction);
  if (target < 0) return menu;
  const next = [...menu];
  [next[index], next[target]] = [next[target], next[index]];
  return next;
}
